@import "/src/styles/mixins.sass"

.container
    padding: 2rem
    display: flex
    flex-wrap: wrap
    gap: 1rem 2rem
    align-items: flex-start

    .br
        flex-basis: 100%

    & > button
        &:nth-of-type(2)
            box-shadow: var(--shadow-primary-hover) !important

        &:nth-of-type(3)
            box-shadow: var(--shadow-focus), var(--shadow-primary-hover) !important

        &:nth-of-type(4)
            box-shadow: none !important

    input[type="button"]
        min-width: 12rem

.shifted
    margin-top: 7rem
    display: flex
    gap: 2rem

    input[type="button"]
        min-width: 6rem

.comp
    border: 1px dashed grey
    width: 10rem

    height: 3rem
    display: flex
    justify-content: center
    align-items: center
    font-size: 90%
    color: grey

.textInput
    input
        max-width: 12rem

    &:nth-child(5) input
        border-radius: 0.2rem
        outline: none
        box-shadow: inset 0 -0.25rem 0 0 var(--color-blue-focus)

.rangeInput
    label input
        max-width: 4rem

    input[type="range"]
        min-width: 20rem

.compOutlined
    @include clickable-styled($outlined: true)
    padding: 1rem

    .comp
        width: 15rem

.compOutlinedBlock
    @include clickable-styled($outlined: true, $block: true)
    padding: 1rem

    .comp
        width: 15rem
